import {DataDisplayEvent, LookupModelSelectionEvent} from "@mcleod/components";
import { AutogenLayoutControlFileOverrides } from "./autogen/AutogenLayoutControlFileOverrides";
import {Model, StringUtil} from "@mcleod/core";
const FREIGHT_BILL_TYPE = 'F';
const SUMMARY_TYPE = 'S';
const MISC_BILL_TYPE = 'M';
const DEDICATED_TYPE = 'J';
const RATE_CONFIRMATION = 'Z';

export class ControlFileOverrides extends AutogenLayoutControlFileOverrides {

    onLoad(): void | Promise<void> {
        Model.searchSingleRecord("lme/powerbroker/br-tracking-ctrl", { vendor: "M", is_active: "Y" }).then(response => {
            this.textboxMinsWithinGeofence.visible = StringUtil.equalsIgnoreCase(response?.get("is_active"),"Y");
        });
    }

    textboxWaterfallProcessOnChange(event) {
        const waterfallProcess = this.textboxWaterfallProcess.valueAsString;
        if (waterfallProcess === "A") {
            this.textboxWaterfallNotifyEmail.required = true;
        } else {
            this.textboxWaterfallNotifyEmail.required = false;
            this.textboxWaterfallNotifyEmail.text = "";
            this.textboxWaterfallNotifyEmail.resetValidation();
        }
    }

    textboxBillTemplateBeforeLookupModelSearch(event) {
        event.filter.document_type = FREIGHT_BILL_TYPE;
        event.filter.template_number = ">0";
    }

    textboxSummaryTemplateBeforeLookupModelSearch(event) {
        event.filter.document_type = SUMMARY_TYPE;
        event.filter.template_number = ">0";
    }

    textboxMiscBillTemplateBeforeLookupModelSearch(event) {
        event.filter.document_type = MISC_BILL_TYPE;
        event.filter.template_number = ">0";
    }

    textboxDedicatedTemplateBeforeLookupModelSearch(event) {
        event.filter.document_type = DEDICATED_TYPE;
        event.filter.template_number = ">0";
    }

    textboxDefRateConfirmTempBeforeLookupModelSearch(event) {
        event.filter.document_type = RATE_CONFIRMATION;
        event.filter.template_number = ">0";
    }

    textboxRequiredVendorBeforeLookupModelSearch(event) {
        event.filter.is_active = true;
    }

    textboxRequiredVendorOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() && event.selection.get("is_dfm")) {
            this.checkboxRequireTracking.checked = true;
        }
    }
}
